/* eslint-disable import/no-cycle */
import React, { FunctionComponent, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import omit from "lodash/omit";
import { RootState } from "../../../../../reducers";
import { setProposedChangesFilterParams } from "../../../../../actions";
import { CustomFilter } from "../../../../DesignSystem/Table/Filter/CustomFilter";
import { GenericType } from "../../../map/deckgl/interfaces";

const GetFilterDataforColumn = (filterParam: string): Array<{ label: string; value: string }> => {
    const filterData = useSelector((state: RootState) =>
        filterParam === "source_ids__in"
            ? state.regulationListView.sensorIdsFilterData
            : state.regulationListView.filtersData
    );

    return filterData
        ?.filter((i) => i.is_filtering_enabled)
        ?.filter((i) => i.column_filter_name === filterParam)?.[0]?.values;
};

export const ProposedChangesFilter: FunctionComponent = (props: GenericType) => {
    const { column } = props;

    const selectOptions = column.filterParam ? GetFilterDataforColumn(column.filterParam) : [];

    const [selectedValue, setSelectedValue] = useState<string[]>([]);

    const [sortedColumnID, setSortedColumnID] = useState<string>("");

    const proposedChangesParams = useSelector(
        (state: RootState) => state.regulationListView.proposedChangesParams
    );

    const dispatch = useDispatch();

    useEffect(() => {
        if (proposedChangesParams[column.filterParam]) {
            setSelectedValue(proposedChangesParams[column.filterParam] as string[]);
        } else {
            setSelectedValue([]);
        }
        setSortedColumnID(proposedChangesParams.ordering as string);
    }, [proposedChangesParams, column]);

    const handleApply = (checkedValues: string[]): void => {
        const updatedProposedChangesParams = {
            ...proposedChangesParams,
            [column.filterParam]: checkedValues,
            offset: 0
        };

        dispatch(setProposedChangesFilterParams({ params: updatedProposedChangesParams }));
    };

    const handleClear = (): void => {
        const updatedProposedChangesParams = omit(proposedChangesParams, column.filterParam);

        dispatch(setProposedChangesFilterParams({ params: updatedProposedChangesParams }));
        column.clearSortBy();

        const allCheckBoxes = document.getElementsByName(props.column.id);

        for (let i = 0; i < allCheckBoxes.length; i++) {
            (allCheckBoxes[i] as HTMLInputElement).checked = false;
        }
        setSelectedValue([]);
    };

    return (
        <CustomFilter
            handleApply={handleApply}
            handleClear={handleClear}
            isSorted={sortedColumnID ? sortedColumnID.includes(column.id) : false}
            props={props}
            selectOptions={selectOptions}
            selectedValue={selectedValue}
        />
    );
};
